import router from "app/router";
import { store } from "../app/store";
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { createAction } from "@reduxjs/toolkit";

const request = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const { method, url } = config;
    // Set Headers Here
    // Check Authentication Here
    // Set Loading Start Here
    const token = localStorage.getItem("token")
    config.headers.Authorization = token;
    return config;
};

const customRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const { method, url } = config;
    // Set Headers Here
    // Check Authentication Here
    // Set Loading Start Here
    const token = localStorage.getItem("token")
    const access_token = localStorage.getItem("access_token")
    config.headers.Authorization = token;
    config.headers.BoldAuthorization = access_token;
    return config;
};

const boldBIRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const access_token = localStorage.getItem("access_token")
    config.headers.Authorization = `bearer ${access_token}`;
    return config;
};

const requestError = (error: AxiosError | Error): Promise<AxiosError> => {
    return Promise.reject(error)
}

const response = (response: AxiosResponse): AxiosResponse => {
    const { method, url } = response.config;
    const { status } = response;
    // Set Loading End Here
    // Handle Response Data Here
    // Error Handling When Return Success with Error Code Here
    return response;
}

const responseError = (error: AxiosError | Error): Promise<AxiosError> => {
    if (axios.isAxiosError(error)) {
        const { message } = error;
        const { method, url } = error.config as AxiosRequestConfig;
        const { statusText, status } = error.response as AxiosResponse ?? {};
        const { dispatch } = store
        const logoutAction = createAction("logout");
        switch (status) {
            case 401: {
                localStorage.clear()
                dispatch(logoutAction());
                router.navigate("/auth/login")
                // "Login required"
                break;
            }
            case 403: {
                // "Permission denied"
                break;
            }
            case 404: {
                // "Invalid request"
                break;
            }
            case 500: {
                // "Server error"
                break;
            }
            default: {
                // "Unknown error occurred"
                break;
            }
        }

        // if (status === 401) {
        //     // Delete Token & Go To Login Page if you required.
        // }
    }
    return Promise.reject(error);
}

export const setupInterceptors = (instance: AxiosInstance): AxiosInstance => {
    instance.interceptors.request.use(request, requestError);
    instance.interceptors.response.use(response, responseError);
    return instance;
};

export const setupCustomInterceptor = (instance: AxiosInstance): AxiosInstance => {
    instance.interceptors.request.use(customRequest, requestError);
    instance.interceptors.response.use(response, responseError);
    return instance;
};

export const setupBoldBIInterceptor = (instance: AxiosInstance): AxiosInstance => {
    instance.interceptors.request.use(boldBIRequest, requestError);
    instance.interceptors.response.use(response, responseError);
    return instance;
};